/**
 * @fileoverview AppLogo — single source of truth do logo do APP.
 *
 * Antes deste componente, o SVG do play+gradient estava duplicado em 3
 * lugares (`apps/tv/index.html`, o antigo `BandwidthProbeOverlay.tsx`,
 * `WelcomeScreen.tsx`). Issue paleta APP vs PROVIDER (PR #34).
 *
 * Marca real: renderiza o SÍMBOLO LIMPO da marca (S+play roxo outline,
 * transparente, sem texto) a partir de `assets/brand/symbol-mark.png`. Sobre o
 * fundo escuro do app o símbolo "flutua" — fica mais elegante que o
 * app-icon de fundo roxo sólido (a caixa roxa pesava sobre o escuro).
 * Usamos o MARK isolado (não o lockup `symbol.png`/`logo-horizontal.png`
 * que já trazem o texto "swipe tv") porque este componente aparece sozinho
 * (Welcome, Mobile) e ao lado de outros wordmarks — um lockup com texto
 * aqui duplicaria a marca. O asset é quadrado e centrado (padding interno),
 * então a assinatura (size = lado do quadrado, className) é preservada e
 * não há risco de distorção/layout pros consumers (WelcomeScreen TV,
 * MobileShell, etc).
 *
 * Splash inicial (`apps/tv/index.html`) usa `<img>` do mesmo símbolo direto
 * no HTML (pré-bootstrap, sem JS/tokens.css) — mantido em sync manual, e por
 * isso o asset também vive em `public/brand/` (path relativo `./brand/...`).
 *
 * Aqui (dentro do bundle) o asset é IMPORTADO de `src/assets/brand/` para o
 * Vite reescrever a URL com hash + base relativa (`base:'./'`) — path ABSOLUTO
 * `/brand/...` viraria `file:///brand/...` (404) nos wrappers webOS/Tizen que
 * carregam o index via file://.
 */

import symbolMark from '../assets/brand/symbol-mark.png'

import styles from './AppLogo.module.css'

interface AppLogoProps {
  /** Lado em px do ícone quadrado. Default 72 (tamanho da Welcome). */
  size?: number | undefined
  /** Classes adicionais — útil pra animations específicas (pulse) ou
   *  positioning. */
  className?: string | undefined
}

export function AppLogo({ size = 72, className }: AppLogoProps) {
  const cls = [styles.logo, className].filter(Boolean).join(' ')
  return (
    <div className={cls} style={{ width: size, height: size }} aria-hidden="true">
      <img
        className={styles.icon}
        src={symbolMark}
        alt=""
        width={size}
        height={size}
        // Decode assíncrono: símbolo pequeno, não bloqueia o 1º paint da
        // tela (Welcome/boot).
        decoding="async"
      />
    </div>
  )
}
